import React from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import Competitor from "components/presentation/Competitor";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SportCode from 'components/common/SportCode'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { isGroups } from "../../helpers/GryHelpers";



const asterisc = <FontAwesomeIcon className="font-icon" icon={faAsterisk} />;

export const PreviousCurrent = (props) => {
    const { current, previous, cumulative } = props;
    const { mirs_discipline, mirs_rsc} = useUrlFriendlyToParameters()
    
    const { breakPoint } = useViewport()
    const isMobile = breakPoint === 'sm' || breakPoint === 'xs';

    const apparatusPrevious = previous?.eventUnitEntries?.find(eue => eue?.eue_code === 'APPARATUS')?.eue_value;
    const apparatusCurrent = current?.eventUnitEntries?.find(eue => eue?.eue_code === 'APPARATUS')?.eue_value;
    const cumulativeIrmOrScore = cumulative?.resultIrm ? <SportCode discipline={mirs_discipline} entity='@IRM' code={cumulative?.resultIrm} abbr={true} /> : cumulative?.resultData ? <>{cumulative?.resultData}</> : <></> 

    const needed = current?.extendedResultsCurrent?.find(r => r?.er_code === 'STAGE' && r?.er_value ==='CURRENT')?.extensions?.filter(e => e?.ere_code === 'NEED')?.sort((a, b) => a?.ere_pos - b?.ere_pos);
    
    const xlPrevious = (<>
        <table className="table table-sm table-bordered border">
            <caption><Label data='HeaderPreviousComp' /></caption>
            <thead>
                <tr>
                    <th className="w-5 text-end"><Label data={'LabelStartOrderN'} /></th>
                    <th className="text-start"><Label data={isGroups(mirs_rsc) ? 'HeaderTeam' : 'HeaderName'} /></th>
                    <th className="w-10 text-center"><Label data={'HeaderApparatus'} /></th>
                    <th className="w-15 text-center"><Label data={'HeaderApparatusScore'} /></th>
                    <th className="w-15 text-center"><Label data={'HeaderAllAroundScore'} /></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-end" rowSpan='2'>{previous?.startOrder}</td>
                    <td className="text-start" rowSpan='2'><Competitor {...previous?.participant} alwaysNoc={true} hidePicture={true}/></td>
                    <td className="text-center" rowSpan='2'>{apparatusPrevious && <SportCode discipline={mirs_discipline} entity='@APPARATUS' code={apparatusPrevious} />}</td>
                    <td className="text-end">{previous && <ApparatusScorePoints results={previous?.extendedResultsCurrent} />}</td>
                    <td className="text-end"></td>
                </tr>
                <tr>
                    <td className="text-end">{previous && <ApparatusScoreTotal results={previous?.extendedResultsCurrent} />}</td>
                    <td className="text-end">{previous && <AllAroundScore results={previous} />}</td>
                </tr>
            </tbody>
        </table>
    </>)

const xsPrevious = (<>
    <table className="table table-sm table-bordered border">
        <thead>
            <tr>
                <th className="text-start"><Label data={'HeaderPreviousComp'} /></th>
                <th className="w-10 text-end">{apparatusPrevious && <SportCode discipline={mirs_discipline} entity='@APPARATUS' code={apparatusPrevious} />}</th>
                <th className="w-10 text-end"><Label data={'HeaderTotal'} /></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className="text-start" rowSpan='2'><Competitor {...previous?.participant} alwaysNoc={true} hidePicture={true}/></td>
                <td className="text-end" rowSpan='2'><ApparatusScoreTotal results={previous?.extendedResultsCurrent} /></td>
                <td className="text-end"><AllAroundScore results={previous} /></td>
            </tr>
        </tbody>
    </table>
</>)

const xlCurrent = (<>
        <table className="table table-sm table-bordered border">
            <caption><Label data='LabelCurrentCompetitor' /></caption>
            <thead>
                <tr>
                    <th className="w-5 text-end"><Label data={'LabelStartOrderN'} /></th>
                    <th className="text-start"><Label data={isGroups(mirs_rsc) ? 'HeaderTeam' : 'HeaderName'} /></th>
                    <th className="w-10 text-center"><Label data={'HeaderApparatus'} /></th>
                    <th className="w-15 text-center"><Label data={'HeaderCurrentOverallScore'} /></th>
                    { needed &&                  
                    <th className="w-15 text-center"><Label data={'HeaderScoreNeededFor'} /></th>
                    }
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-end" >{current?.startOrder}</td>
                    <td className="text-start" ><Competitor {...current?.participant} alwaysNoc={true} hidePicture={true}/></td>
                    <td className="text-center">{apparatusCurrent && <SportCode discipline={mirs_discipline} entity='@APPARATUS' code={apparatusCurrent} />}</td>
                    <td className="text-center">{cumulativeIrmOrScore}</td>
                    { needed && 
                    <td className="text-end"><ScoreNeededFor data={needed} /></td>
                    }
                </tr>
            </tbody>
        </table>
    </>)

    const xsCurrent = (<>
        <table className="table table-sm table-bordered border">
            <thead>
                <tr>
                    <th className="text-start"><Label data={'LabelCurrentCompetitor'} /></th>
                    <th className="w-20 text-end"><Label data={'HeaderApparatus'} /></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-start" ><Competitor {...current?.participant} alwaysNoc={true} hidePicture={true}/></td>
                    <td className="text-end">{apparatusCurrent && <SportCode discipline={mirs_discipline} entity='@APPARATUS' code={apparatusCurrent} />}</td>
                </tr>
            </tbody>
        </table>
    </>)
   

return <>
        { !previous ? <></> : isMobile ? xsPrevious : xlPrevious }
        { !current  ? <></> : isMobile ? xsCurrent  : xlCurrent  }
    </>

}

const ApparatusScorePoints = ({results}) => {
    const extensions = results?.find(r => r?.er_valuetype === 'POINTS')?.extensions;     
    const penalty = extensions?.find(e => e?.ere_code === 'PENALTY')?.ere_value;
    return (
    <table className="table table-sm table-borderless">
        <tbody>
            <tr>
                <td className="text-start"><Label data='HeaderDifficulty' /></td>
                <td>{extensions?.find(e => e?.ere_code === 'DIFFICULTY')?.ere_value}</td>
            </tr>
            <tr>
                <td className="text-start"><Label data='HeaderArtistry' /></td>
                <td>{extensions?.find(e => e?.ere_code === 'ARTISTIC')?.ere_value}</td>
            </tr>
            <tr>
                <td className="text-start"><Label data='HeaderExecution' /></td>
                <td>{extensions?.find(e => e?.ere_code === 'EXECUTION')?.ere_value}</td>
            </tr>
            {penalty &&
            <tr>
                <td className="text-start"><Label data='HeaderPenalty' /></td>
                <td>{penalty}</td>                
            </tr>
            }
        </tbody>
    </table>);
}


const ApparatusScoreTotal = ({results}) => {
    const { breakPoint } = useViewport()
    const isMobile = breakPoint === 'sm' || breakPoint === 'xs';

    const { mirs_discipline } = useUrlFriendlyToParameters()
    const score = results?.find(r => '|3_RIBBONS_2_BALLS|5_HOOPS|BALL|CLUBS|HOOP|RIBBON|'.includes(r?.er_code));
    const extensions = score?.extensions;     
    const inquiry = extensions?.find(e => e?.ere_code === 'INQUIRY' && e?.ere_value === 'SUBMITTED') ? <>{asterisc}</> : <></>;
    const irmOrScore = score?.er_irm ? <SportCode discipline={mirs_discipline} entity='@IRM' code={score?.er_irm} abbr={true} /> : score?.er_value ? <>{score?.er_value}</> : <></> 
    
    const xl = (
        <table className="table table-sm table-borderless">
            <tbody>
                <tr>
                    <td className="text-start"><Label data='HeaderTotal' /></td>
                    <td>{inquiry}{irmOrScore}</td>
                </tr>
                <tr>
                    <td className="text-start"><Label data='HeaderRank' /></td>
                    <td>{score?.er_rank}</td>
                </tr>
            </tbody>
        </table>
    );
   
    const xs = (
        <table className="table table-sm table-borderless">
            <tbody>
                <tr><td>{inquiry}{irmOrScore}</td></tr>
                <tr><td>{score?.er_rank ? `(${score?.er_rank})` : ''}</td></tr>
            </tbody>
        </table>
    )
    
   return isMobile ? xs : xl;
}

const AllAroundScore = ({results}) => {
    const { breakPoint } = useViewport()
    const isMobile = breakPoint === 'sm' || breakPoint === 'xs';

    const { mirs_discipline } = useUrlFriendlyToParameters()
    const irmOrScore = results?.resultIrm ? <SportCode discipline={mirs_discipline} entity='@IRM' code={results?.resultIrm} abbr={true} /> : results?.resultData ? <>{results?.resultData}</> : <></> 

    const xl = (
        <table className="table table-sm table-borderless">
            <tbody>
                <tr>
                    <td className="text-start"><Label data='HeaderTotal' /></td>
                    <td>{irmOrScore}</td>
                </tr>
                <tr>
                    <td className="text-start"><Label data='HeaderRank' /></td>
                    <td>{results?.resultRank}</td>
                </tr>
            </tbody>
        </table>
    );

    const xs = (
        <table className="table table-borderless table-sm ">
            <tbody>
                <tr><td>{irmOrScore}</td></tr>
                <tr><td>{results?.resultRank ? `(${results?.resultRank})` : ''}</td></tr>
            </tbody>
        </table>
    );

    return isMobile ? xs : xl;
}

const ScoreNeededFor = ({data}) => {
    return (
    <table className="table table-borderless table-sm">
        <tbody>
            {data?.map(n =>(
                <tr key={n?.ere_pos}>
                    <td className="text-start"><Label data='HeaderRank' /> {n?.ere_pos}:</td>
                    <td className="text-end">{n?.ere_value}</td>
                </tr>
                ))
            }
        </tbody>
    </table>);

}


